var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.978,
    height: 20.25,
    viewBox: "0 0 19.978 20.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2144",
    "data-name": "Raggruppa 2144",
    transform: "translate(-3.272 -3)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1",
    "data-name": "Ellisse 1",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(8 4)",
    fill: "none",
    stroke: "#12181f",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3257",
    "data-name": "Tracciato 3257",
    d: "M13.327,15.076A11.614,11.614,0,0,0,12,15a10.843,10.843,0,0,0-5.369,1.373,7.221,7.221,0,0,0-3.3,3.737,1,1,0,1,0,1.883.673,5.234,5.234,0,0,1,2.414-2.677,8.628,8.628,0,0,1,3.529-1.07A3.005,3.005,0,0,1,13.327,15.076Z",
    fill: "#12181f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3258",
    "data-name": "Tracciato 3258",
    d: "M18,14v8",
    fill: "none",
    stroke: "#12181f",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3259",
    "data-name": "Tracciato 3259",
    d: "M22,18H14",
    fill: "none",
    stroke: "#12181f",
    strokeLinecap: "round",
    strokeWidth: 2.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminBlack);
export default __webpack_public_path__ + "static/media/admin-black.5c981dbf3c1fcc218c5a9bb07648ccb1.svg";
export { ForwardRef as ReactComponent };